new WOW().init();
Fancybox.bind('[data-fancybox]:not([data-product-lightbox])', {});
const heroMotionReduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
Fancybox.bind('[data-product-lightbox]', {
  animated: () => !heroMotionReduced(),
  showClass: () => (heroMotionReduced() ? false : 'f-zoomInUp'),
  hideClass: () => (heroMotionReduced() ? false : 'f-fadeOut'),
  Carousel: {
    transition: () => (heroMotionReduced() ? false : 'fade'),
    friction: () => (heroMotionReduced() ? 0 : 0.12),
  },
});
// document.addEventListener("DOMContentLoaded", function () {
//   if (window.location.pathname.includes("/products/haptique-rs90")) {
//     window.location.href = "/";
//   }
// });


jQuery(document).ready(function ($) {
  function appHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
    const header = document.querySelector("header");
    document.documentElement.style.setProperty(
      "--header-height",
      `${header.offsetHeight}px`
    );
  }
  appHeight();
  $(window).resize(function () {
    appHeight();
  });



// header
  var $win = $(window), $body = $('body');
  $('.menuIcon').on('click', function (e) {
    e.preventDefault();
    $body.toggleClass('is-nav-open');
  });

  $('.nav-overlay').on('click', function () {
    $body.removeClass('is-nav-open');
  });

// if ($(window).width() < 1199) {
//   $('.has-dropdown > a').on('click', function (e) {
//     e.preventDefault();
//     const $parent = $(this).parent('.has-dropdown');
//     $parent.toggleClass('open');
//   });
// }

if ($(window).width() < 1199) {
  $('.has-dropdown > a').on('click', function (e) {
    e.preventDefault();
    const $megaMenu = $(this).siblings('.mega-menu');
    $('.mega-menu').not($megaMenu).removeClass('active'); 
    $megaMenu.toggleClass('active');
  });

  $(document).on('click', '.mega-menu-head', function (e) {
    e.preventDefault();
    $(this).closest('.mega-menu').removeClass('active');
  });
}






  // Sticky Header
  var lastScrollTop = 0;

  $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();

    // If we are scrolling down and scroll position is greater than or equal to 50, remove the sticky class
    if (scrollTop > lastScrollTop && scrollTop >= 50) {
      $("body").removeClass("header-is-sticky");
    }
    // If we are scrolling up or at the top (scroll position is 0 or less than 50), add the sticky class
    else if (scrollTop < lastScrollTop || scrollTop <= 50) {
      $("body").addClass("header-is-sticky");
    }

    // Ensure that sticky class is removed when you scroll back to the top (scrollTop == 0)
    if (scrollTop < 100) {
      $("body").removeClass("header-is-sticky");
    }

    // Update the last scroll position
    lastScrollTop = scrollTop;
  });

  // Scroll To Top
  $(window).scroll(function () {
    var x = $(document).scrollTop();
    if (x > 100) {
      $(".back-to-top").addClass("active");
    } else {
      $(".back-to-top").removeClass("active");
    }
  });
  $(".back-to-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  $(".video-gallery").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 4,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },
    ],
  });

  window.HaptiqueProductHero?.initAll(document);

  if (screen.width >= 991) {
  $('.product-gallery-main, .product-content-main').filter(function () {
    return !this.closest('[data-product-hero]');
  }).theiaStickySidebar({
  additionalMarginTop: 20,
  });
  }
});

$('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('[data-toggle="tab"]')
  .click(function (event) {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {

      var target = $(this.hash);

      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

      if (target.length) {

        event.preventDefault();

        $("html, body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000,
          function () {

            var $target = $(target);

            $target.focus();

            if ($target.is(":focus")) {

              return false;
            } else {
              $target.attr("tabindex", "-1");

              $target.focus();
            }
          }
        );
      }
    }
  });

function copyCode() {
  var promoCode = document.getElementById("promoCode").innerText;
  var button = document.querySelector(".btn-copy");
  var originalText = button.innerHTML;

  if (navigator.clipboard) {
    navigator.clipboard.writeText(promoCode).then(
      function () {},
      function (err) {
        console.error("Could not copy text: ", err);
      }
    );
  } else {
    var textArea = document.createElement("textarea");
    textArea.value = promoCode;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Could not copy text: ", err);
    }
    document.body.removeChild(textArea);
  }

  button.innerHTML = "Copied!";
  setTimeout(function () {
    button.innerHTML = originalText;
  }, 3000);
}
let mobileMedia = window.matchMedia("(max-width: 1200px)");
if (mobileMedia.matches) {
  $(".testimonial-box").slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
} else {
  $(document).ready(function () {
    const items = $(".testimonial-item-wrap");
    let currentIndex = 0;
    const offsetAdjustment = 60;
    const itemGap = 20;

    $(".testi-next").click(function () {
      if (currentIndex < items.length - 1) {
        currentIndex++;
        const nextItemOffset =
          $(items[currentIndex]).offset().top - offsetAdjustment - itemGap;
        $("html, body").animate({ scrollTop: nextItemOffset }, 500);
      }
    });

    $(".testi-prev").click(function () {
      if (currentIndex > 0) {
        currentIndex--;
        const prevItemOffset =
          $(items[currentIndex]).offset().top - offsetAdjustment - itemGap;
        $("html, body").animate({ scrollTop: prevItemOffset }, 500);
      }
    });

    $(window).scroll(function () {
      items.each(function (index) {
        if (
          $(window).scrollTop() >=
          $(this).offset().top - offsetAdjustment - itemGap - 10
        ) {
          currentIndex = index;
        }
      });
    });
  });
}
// gsap.registerPlugin(ScrollTrigger);

// let desktop = window.matchMedia("(min-width: 1199px)");

// if (desktop.matches) {
//     if (document.getElementsByClassName("testimonial-section").length > 0) {
//         let mediaSecHeight = document.querySelector(".testimonial-section").offsetHeight;
//         let mediaListHeight = document.querySelector(".testimonial-box").offsetHeight;
//         let mediaTotalScrollableHeight = mediaListHeight - mediaSecHeight;

//         gsap
//             .timeline({
//                 scrollTrigger: {
//                     trigger: ".testimonial-section",
//                     pin: true,
//                     scrub: 0.5,
//                     start: () => "top top",
//                     end: () => "+=" + mediaListHeight,
//                     markers: false,
//                 },
//             })
//             .to(".testimonial-box", { y: -mediaTotalScrollableHeight });

//         const scrollSections = gsap.utils.toArray(".testimonial-item");

//         scrollSections.forEach((section) => {
//             ScrollTrigger.create({
//                 trigger: section,
//                 start: "top center",
//                 end: "+=100% center",
//                 markers: false,
//             });
//         });
//     }
// } else {
//     $(".testimonial-box").slick({
//         dots: true,
//         infinite: true,
//         arrows: false,
//         autoplay: true,
//         autoplaySpeed: 2000,
//         speed: 300,
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         responsive: [
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                 },
//             },
//         ],
//     });
// }

$(".latest-blog-slider").slick({
  dots: false,
  infinite: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots:true,
      },
    },
  ],
});
